import { useCallback } from 'react';
import { useAppSelector } from '../store/hooks';
import { canUseRoute, rolesForRoute, HttpMethod, StaffRole } from '../constants/staffRoles';
import { canOpenPath } from '../components/nav-section';

// ----------------------------------------------------------------------

const NO_ROLES: string[] = [];

// What the logged-in staff user may do, from their roles (login answer or GET /staff/me).
// The backend still answers 403 NOT_ALLOWED when the roles don't cover a call.
const useStaffAccess = () => {
  const roles = useAppSelector((state) => state.auth.roles) || NO_ROLES;

  // can('PUT', '/owner/trial-settings'), can('PATCH', '/owner/plans/{plan_id}/activate')
  const can = useCallback(
    (method: HttpMethod, path: string) => canUseRoute(roles, method, path),
    [roles]
  );

  const hasAnyRole = useCallback(
    (allowed: StaffRole[] | string[]) => roles.some((r) => (allowed as string[]).includes(r)),
    [roles]
  );

  // canOpen(PATH_DASHBOARD.material.stuck): whether a page of the menu opens for these roles
  const canOpen = useCallback((path: string) => canOpenPath(path, roles), [roles]);

  return { roles, can, hasAnyRole, canOpen, rolesForRoute };
};

export default useStaffAccess;
